<template>
    <div class="normal-box">
        <el-row class="normal-box-bg">
            <el-row class="normal-box-title">
                 <h2>
                    什么是高职单招?
                    <div class="normal-box-title-line"></div>
                </h2>
                <p>
                    高职单招是指考生不参加高考，直接参加专科学校的招生考试，选择高职单招的考生通常是文化成绩不好，在高考中没有什么优势的考生。这样的学生能够用不高的分数考取一所较好的专科学校，拿到和普通高考考生一样的文凭。
                </p>
            </el-row>
        </el-row>
        <el-row class="normal-box-tips-bg">
            <el-row class="normal-box-common normal-box-tips-list normal-box-common1">
            <h3>
                <span class="high-box-arrow-right"></span>
                招生流程
                <span class="high-box-arrow-left"></span>
            </h3>
                <el-row class="normal-box-tips-time">
                    <span class="normal-box-tips-line"></span>
                    <span class="normal-box-tips-arrow"></span>
                </el-row>
                <el-row class="normal-box-tips" type="flex">
                    <div class="normal-box-tips-item2 normal-box-tips-item-common1 normal-box-tips-item-common">
                        <div class="normal-box-tips-content">
                            <span>11月底</span><br>
                            高考报名取得报考资格
                        </div>
                        <div class="normal-box-tips-arrow1"></div>
                        <span class="normal-box-tips-circle"></span>
                    </div>
                    <div class="normal-box-tips-item3 normal-box-tips-item-common1">
                        <span class="normal-box-tips-circle"></span>
                        <div class="normal-box-tips-arrow1"></div>
                        <div class="normal-box-tips-content">
                            <span>3月</span><br>
                            网上报考，并及时缴纳报名费，打印准考证
                        </div>
                    </div>
                    <div class="normal-box-tips-item4 normal-box-tips-item-common1 normal-box-tips-item-common">
                        <div class="normal-box-tips-content">
                            <span>4月</span><br>
                            在院校规定的考试时间进行单独招生考试/面试
                        </div>
                        <div class="normal-box-tips-arrow1"></div>
                        <span class="normal-box-tips-circle"></span>
                    </div>
                    <div class="normal-box-tips-item5 normal-box-tips-item-common1">
                        <span class="normal-box-tips-circle"></span>
                        <div class="normal-box-tips-arrow1"></div>
                        <div class="normal-box-tips-content">
                            <span>4月</span><br>
                            查看成绩与录取信息
                        </div>
                    </div>
                    <div class="normal-box-tips-item6 normal-box-tips-item-common1 normal-box-tips-item-common">
                        <div class="normal-box-tips-content">
                            <span>7月</span><br>
                            接收录取通知书并按时间入学
                        </div>
                        <div class="normal-box-tips-arrow1"></div>
                        <span class="normal-box-tips-circle"></span>
                    </div>
                </el-row>
            </el-row>
        </el-row>
        <el-row v-if="has_code == 1" class="normal-box-school normal-box-common">
            <h3>
                <span class="high-box-arrow-right"></span>
                    各学校高职单招信息
                <span class="high-box-arrow-left"></span>
            </h3>
            <div class="normal-box-school-infor">
                <div class="normal-box-school-input"> 
                    <el-input v-model="search.scl_name" @keyup.enter.native="searchData" placeholder="搜索学校">
                    <template slot="prepend">
                        <div class="normal-box-school-input-left" @mouseenter="hoverMenuHandler()" @mouseleave="hoverMenuHandler()">
                            筛选
                            <i class="el-icon-arrow-down" v-if="!hoverMenuStatus"></i>
                            <i class="el-icon-arrow-up" v-else></i>
                            <div class="menu-tools-ul" v-if="hoverMenuStatus">
                                <div>
                                    <div class="province-list" v-if="provinceCode === '51'">
                                        <div class="title-box">院校类型：</div>
                                        <div class="province-name">
                                            <a v-for="(item,index) in typeList1" :key="'id1' + index" :class="activeTag1 == index?'active-tag':''" @click="activeTagHandler1(index)">{{item.dic_value}}</a>
                                        </div>
                                    </div>
                                    <div class="province-list">
                                        <div class="title-box">办学类型：</div>
                                        <div class="province-name">
                                            <a v-for="(item,index) in typeList2" :key="'id2' + index" :class="activeTag2 == index?'active-tag':''" @click="activeTagHandler2(index)">{{item.dic_value}}</a>
                                        </div>
                                    </div>
                                    <div class="province-list">
                                        <div class="title-box">学历层次：</div>
                                        <div class="province-name">
                                            <a v-for="(item,index) in typeList3" :key="'id3' + index" :class="activeTag3 == index?'active-tag':''" @click="activeTagHandler3(index)">{{item.dic_value}}</a>
                                        </div>
                                    </div>
                                     <div class="province-list">
                                        <div class="title-box">城市：</div>
                                        <div class="province-name">
                                            <a v-for="(item,index) in typeList4" :key="'id4' + index" :class="activeTag4 == index?'active-tag':''" @click="activeTagHandler4(index)">{{item}}</a>
                                        </div>
                                    </div>
                                    <div class="normal-box-school-input-btns">
                                        <el-button @click="resetData">重置</el-button>
                                        <el-button @click="searchData" class="normal-box-school-input-confirm">查询</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template slot="append">
                        <img @click="searchData" src="../../assets/images/sousuo.png" alt="搜索">
                    </template>
                </el-input>
                </div>
                <el-scrollbar v-if="requestStatus === '3'">
                    <el-table :key="provinceCode" border :data="schoolList" v-if="provinceCode === '51'">
                        <el-table-column label="招生代码" width="80">
                            <template slot-scope="scope">
                                {{ scope.row.plan_code?scope.row.plan_code:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="院校名称" prop="scl_name" width="178" />
                        <el-table-column label="性质" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.scl_type?scope.row.scl_type:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="城市" width="65">
                            <template slot-scope="scope">
                                {{ scope.row.city?scope.row.city:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="专业限制" width="95">
                            <template slot-scope="scope">
                                {{ scope.row.special_sel_adv?scope.row.special_sel_adv:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="录取规则" width="214">
                            <template slot-scope="scope">
                                {{ scope.row.scoring_method?scope.row.scoring_method:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="总分" width="72">
                            <template slot-scope="scope">
                                {{ scope.row.total_score?scope.row.total_score:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column v-for="(item, index) in yearList" :key="index" :label="item">
                            <el-table-column label="招生计划" width="105">
                                <template slot-scope="scope">
                                {{ !scope.row[item]?'-':scope.row[item].plan?scope.row[item].plan:'-' }}
                            </template>
                            </el-table-column>
                            <el-table-column label="最低控制线" width="123">
                                <template slot-scope="scope">
                                    {{ !scope.row[item]?'-':scope.row[item].sp_min?scope.row[item].sp_min:'-' }}
                            </template>
                            </el-table-column>
                            <!-- <el-table-column label="录取详情" width="108">
                                
                            </el-table-column> -->
                        </el-table-column>
                    </el-table>
                    <el-table :key="provinceCode" border :data="schoolList" v-else>
                        <el-table-column label="院校名称" prop="scl_name" width="178" />
                        <el-table-column label="性质" width="100">
                            <template slot-scope="scope">
                                {{ sclNatureList[scope.row.scl_nature] ? sclNatureList[scope.row.scl_nature] : '' }} {{ sclNatureTypeList[scope.row.scl_nature_type] ? sclNatureTypeList[scope.row.scl_nature_type] : '' }}
                                {{ !sclNatureTypeList[scope.row.scl_nature_type] && !sclNatureList[scope.row.scl_nature] ? '-' : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="城市" width="80">
                            <template slot-scope="scope">
                                {{ scope.row.city?scope.row.city:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="高中生录取规则" width="350">
                            <template slot-scope="scope">
                                {{ scope.row.sp_rule.high_school_student?scope.row.sp_rule.high_school_student:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="中职生录取规则" width="350">
                            <template slot-scope="scope">
                                {{ scope.row.sp_rule.secondary_vocational_student?scope.row.sp_rule.secondary_vocational_student:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="招生人数" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.sp_num?scope.row.sp_num:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="录取优先级" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.sp_priority?scope.row.sp_priority:'-' }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-scrollbar>
                <div class="no-data-box" v-else-if="requestStatus === '2'">
                    <img src="../../assets/images/null.png" alt="没有数据">
                    <p>暂无数据</p>
                </div>
                <el-pagination background layout="prev, pager, next, jumper" :total="total" :page-size="20" @current-change="getSchoolListHandler" :current-page.sync="currentPage" v-if="requestStatus === '3'">
                </el-pagination>
            </div>
        </el-row>
        <el-row class="normal-box-question normal-box-common normal-box-common1">
            <h3>
                <span class="high-box-arrow-right"></span>
                高职单招常见问题解答
                <span class="high-box-arrow-left"></span>
            </h3>
            <el-collapse class="normal-box-question-list">
                <el-collapse-item v-for="(item, index) in questionList" :key="index" :title="item.title" :name="index">
                    <div v-html="item.desc" />
                </el-collapse-item>
            </el-collapse>
        </el-row>
        <el-row v-if="provinceCode === '41'" class="normal-box-nan normal-box-common normal-box-common1">
            <h3>
                <span class="high-box-arrow-right"></span>
                报考难点
                <span class="high-box-arrow-left"></span>
            </h3>
            <img src="../../assets/images/high-nan-img.png">
            <el-row style="margin-top: 64px;">
                <el-row class="normal-box-nan-list">
                    <el-col class="normal-box-nan-item" style="margin-right: 154px">
                        高职院校鱼龙混杂不知如何筛选
                    </el-col>
                    <el-col class="normal-box-nan-item" style="margin-left: 154px">
                        看不懂院校的招生章程
                    </el-col>
                </el-row>
                <el-row class="normal-box-nan-list">
                    <el-col class="normal-box-nan-item" style="margin-right: 154px">
                        不知道可以填报什么专业
                    </el-col>
                    <el-col class="normal-box-nan-item" style="margin-left: 154px">
                        职业测试不知该如何备考
                    </el-col>
                </el-row>
            </el-row>
        </el-row>
        <el-row v-if="provinceCode === '51'" class="normal-box-service normal-box-common">
            <h3>
                <span class="high-box-arrow-right"></span>
                预约咨询,获取高职单招资料
                <span class="high-box-arrow-left"></span>
            </h3>
            <div class="normal-box-service-list">
                <img src="../../assets/images/high-book.png">
                <el-row :gutter="36">
                    <el-col  v-for="(item, index) in bookList" :key="index" :span="8">{{ item }}</el-col>
                </el-row>
            </div>
            <el-row class="normal-box-infor normal-box-order">
                <el-row>
                    <el-col :span="15" style="border-right: 1px solid rgba(255,255,255,0.44);">
                        <div class="normal-box-order-title">
                           提交信息 免费预约
                        </div>
                        <el-form :inline="true" :model="formInline" class="order-form-inline-diff" :rules="rules" ref="formInline">
                            <el-form-item label="姓名：" prop="username">
                                <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="电话：" prop="phone">
                                <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                            </el-form-item>
                            <div>
                                <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                            </div>
                        </el-form>
                    </el-col>
                    <el-col :span="9">
                        <div class="normal-box-order-img">
                            <img src="../../assets/images/high-code.png">
                        </div>
                        <p>QQ扫码加入高职单招交流群</p>
                        <p>获取更多高职单招信息</p>
                    </el-col>
                </el-row>
            </el-row>
        </el-row>
        <el-row v-else class="normal-box-service-diff normal-box-common normal-box-common1">
            <el-row class="normal-box-infor normal-box-order">
                <img src="../../assets/images/channel-order.png" alt="">
                <div>
                    <span class="normal-box-order-title">预约专家 免费咨询</span>
                    <span class="normal-box-order-desc">留下联系方式，立即与专家一对一</span>
                </div>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-row>
        </el-row>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
import { getSchoolList } from '@/api/high_school'
import { mapState } from "vuex"

export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        return {
            bookList: ['四川省高职单招考试复习指导（语文）', '四川省高职单招考试复习指导（数学）', '四川省高职单招考试复习指导（英语）', '四川省高职单招考试复习指导（综合笔试）', '四川省高职单招考试复习指导（综合面试）'],
            serviceList: [
                {src:require('../../assets/images/high-you-icon1.png'),title:'团队优势',desc:'荔枝新高考顶级专家团队全程跟踪,一对一线上线下规划指导'},
                {src:require('../../assets/images/high-you-icon2.png'),title:'流程优势',desc:'一站式服务、自我评估、目标定位、院校选择多重指导等'},
                {src:require('../../assets/images/high-you-icon3.png'),title:'品牌保障',desc:'可靠的品牌支撑，实力、可信、靠谱'},
            ],
            questionList: [{
                title:'什么是高职单招？高职单招与普通高考有什么区别？',
                desc:'<p>高职院校单独招生(简称高职单招)是为贯彻落实《国务院关于大力发展职业教育的决定》精神，全面推进素质教育，突出高职教育特色，积极推进高考招生制度改革，选拔综合素质高和具有创新能力、实践能力、特殊才能的优秀高中毕业生进入高职院校学习而推出的重大政策，即高等职业教育院校根据自身专业教学需要设置考试科目，自主命题、考试、评卷、面试、录取。高职单招主要是本省院校面向本省考生进行招生，一旦被录取，就不需要参加6月份的高考了。</p><h4>单招和统招的区别：</h4><p>1.考试时间不一样，普通高考为6月份，高职单招一般在3月份。</p><p>2.统招是指统一招生考试，国家计划内统一招录。目前的普通高校高考（包括中职的单考单招）。通过参加由教育部组织的高考并被录取，毕业后由教育部颁发认证文凭的考生，包括本科生和专科生。单招考试是由省（市）考试院统一组织，各试点单招学校独立命题、自主组织测试。</p>'
            },{
                title:'高职单招考试难不难？',
                desc:'<p>总体来说，高职单招考试的难度要比全国统一的普通高考难度小很多。因为单招考试主要是针对是文化课成绩不是很理想的考生而进行的选拔考试，因此在文化课的考察上要求不会太难。</p>'
            },{
                title:'什么样的学生适合参加高职单招？',
                desc:'<p>具体来说，以下类型考生适合报考高职单招：</p><p>1.文化课成绩不是很理想的学生</p><p>如果考生的文化课成绩不是很理想，尤其中职学校的学生，通过单招考大学，就是一个极不错的途径，相对竞争压力会小很多。</p><p>2.偏科严重的学生</p><p>如果偏科比较严重，建议参加单招。因为单招的考试形式虽然和统招差不多，但是内容简单很多，都是基础知识。即使偏科某个科目，也不会考的太差。</p><p>3.有某种特长</p><p>如果成绩不理想，但是有某种特长，单招不失为一个好的选择。因为单招院校会有一些针对性的专业，如果考生正好擅长，这是一个很好的机会。</p>'
            },{
                title:'高职单招和普通高考的毕业证是一样吗？',
                desc:'<p>参加高职单招被录取的考生与普通高考录取的考生同时入学，在校期间待遇，毕业时享受的就业政策及就业后的工资、福利、职称评定，毕业证书，均与普通高考录取的学生完全一样。</p>'
            },{
                title:'高职单招被录取的学生毕业后是什么学历？',
                desc:'<p>一般单招毕业后拿的是大专文凭。高职单招录取跟高考录取是没有区别的，因为单招的名额其实是从高考招生计划里面抽出来的，也就是说单招录取之后的学生跟高考上去的学生没有任何区别，待遇都一样，毕业证都一样。单招只是一种升学考试方式，俗称“小高考”，从大一入学开始就和高考录取的同学没有任何区别了，只是提前录取而已。</p>'
            },{
                title:'高职单招与普通高考哪个好？',
                desc:'<p>高职单招是在高考统招前的一种招生方式，通过高职单招考试录取的考生与参加高考录取的高职（大专）考生享有同样的待遇。相比较起来，二者都有各自的优缺点。</p><h4>两者各自的优点：</h4><p>高职单招，在高考之前完成录取，相对与高考来说简单很多，单招通过后不需要再参加高考，即便单招未被录取，还可以继续参加高考，相当于多了一次机会。高考统招，选择面大，对于有高考情节的考生，不可或缺。根据成绩可填报本科、专科不同的志愿，可选择多个学校、多个专业作为志愿。两者各自的缺点：高职单招，只能报考一个单招学校的一个专业，选择性小，一旦选定学校和专业就不能再变更。高考统招，难度比较大，同时竞争的考生比较多，被形容为“千军万马过独木桥”。</p>'
            }],
            formInline: {
                username: '',
                phone: '',
                type: '2'
            },
            search: {
                scl_name: '',
                scl_type: '',
                zslx: '',
                scl_nature: '',
                scl_nature_type: '',
                city: '',
            },
            yearList: [],
            schoolList: [],
            currentPage: 1,
            total: 0,
            requestStatus: '1',
            typeList1: [
                { dic_value:'全部',dic_code:'' },
                { dic_value:'普通类',dic_code:'1' },
                { dic_value:'特长类',dic_code:'2' },
                { dic_value:'中职类',dic_code:'3' },
                { dic_value:'艺术类',dic_code:'4' }
            ],
            typeList2: [
                { dic_value:'全部',dic_code:'' },
                { dic_value:'公办',dic_code:'1' },
                { dic_value:'民办',dic_code:'2' }
            ],
            typeList3: [
                { dic_value:'全部',dic_code:'' },
                { dic_value:'本科',dic_code:'1' },
                { dic_value:'专科',dic_code:'2' },
                { dic_value:'专科（双高）',dic_code:'3' }
            ],
            cityList1:['全部','郑州市','开封市','洛阳市','平顶山市','安阳市','鹤壁市','新乡市','焦作市','濮阳市','许昌市','漯河市','三门峡市','商丘市','周口市','驻马店市','南阳市','信阳市'],
            cityList2:['全部','成都','广元','锦阳','德阳','达州','锦阳','宜宾','遂宁','泸州','眉山','乐山','雅安','南充','广安','自贡','巴中','内江'],
            typeList4: [],
            activeTag1: 0,
            activeTag2: 0,
            activeTag3: 0,
            activeTag4: 0,
            sclNatureList: {
                36000: '公办',
                36001: '民办'
            },
            sclNatureTypeList: {
                6000: '本科',
                6001: '专科',
                6002: '中外合作办学'
            },
            hoverMenuStatus: false,
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
            },
            has_code: 0
        };
    },

    computed: {
        ...mapState({
            provinceCode: state => state.user.provinceCode,
            function_code: state => state.user.function_code
        }),
    },

    watch: {
        provinceCode(newVal) {
            this.resetData()
            this.yearList = []
            this.schoolList = []
            this.currentPage = 1
            this.totalData = 0
            if(newVal === '41') {
                this.typeList4 = this.cityList1
            } else {
                this.typeList4 = this.cityList2
            }
           this.getSchoolListHandler()
        },
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00003'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },

    mounted() {
        if(this.provinceCode === '41') {
            this.typeList4 = this.cityList1
        } else {
            this.typeList4 = this.cityList2
        }
        const tmp = this.function_code.filter(item => { return item.function_code === 'F00003'})
        if(tmp.length > 0) {
            this.has_code = tmp[0].has_code
        }
        this.getSchoolListHandler()
    },

    methods: {
        resetData() {
            Object.assign(this.$data.search, this.$options.data().search)
            this.activeTag1 = 0
            this.activeTag2 = 0
            this.activeTag3 = 0
            this.activeTag4 = 0
        },
        searchData() {
            this.currentPage = 1
            this.hoverMenuStatus = false
            this.getSchoolListHandler()
        },
        activeTagHandler1(index) {
            this.activeTag1 = index;
            this.search.zslx = this.typeList1[index].dic_code;
        },
        activeTagHandler2(index) {
            this.activeTag2 = index;
            this.search.scl_nature = this.typeList2[index].dic_code;
        },
        activeTagHandler3(index) {
            this.activeTag3 = index;
            this.search.scl_nature_type = this.typeList3[index].dic_code;
        },
        activeTagHandler4(index) {
            this.activeTag4 = index;
            if(index == '0') {
                this.search.city = '';
            } else {
                this.search.city = this.typeList4[index];
            }
        },
        hoverMenuHandler() {
            this.hoverMenuStatus = !this.hoverMenuStatus;
        },
        getSchoolListHandler() {
            getSchoolList(this.search, this.provinceCode, this.currentPage).then(res => {
                const data = res.data
                if(data.total === 0) {
                    this.requestStatus = '2'
                    return
                }
                this.requestStatus = '3'
                const yearList = []
                if(this.provinceCode === '51') {
                    const schoolList = data.data.map(item => {
                        const tmp = { ...item }
                        if(item.plan_info.length > 0) {
                            item.plan_info.map(item1 => {
                                if(yearList.indexOf(item1.year) === -1) {
                                    yearList.push(item1.year)
                                }
                                tmp[item1.year] = item1
                            })
                        }
                        return tmp
                    })
                    this.yearList = [ ...yearList ]
                    this.schoolList = [ ...schoolList ]
                } else {
                    this.schoolList = [...res.data.data]
                }
                this.total = data.total
            })
        },
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@font-face {
    font-family: 'Impact';
    src: url('../../assets/fonts/Impact.ttf');
}
@font-face {
    font-family: 'zihun443hao';
    src: url('../../assets/fonts/zihun443hao.ttf');
}
$width: 1200px;
$margin: 0 auto;
$font-family: 'MicrosoftYaHei';
.normal-box-bg {
    background: url('../../assets/images/high-bg.png') no-repeat;
    background-size: cover;
    width: 100%;
    height: 512px;
    .normal-box-title {
        margin: 72px auto;
        width: $width;
        height: 368px;
        background: rgba(255,255,255,0.60);
        border-radius: 20px;
        box-shadow: 0px 2px 2px 0px rgba(64,57,54,0.11), 0px 1px 0px 0px rgba(255,255,255,0.50) inset; 
        backdrop-filter: blur(4px);
        padding: 59px 72px;

        h2 {
            font-size: 64px;
            font-family: $font-family;
            font-weight: 700;
            text-align: center;
            color: #ff872e;
            line-height: 85px;
            letter-spacing: 6.4px;
            margin: 0;
            position: relative;
        }

        p {
            font-size: 22px;
            font-family: $font-family;
            font-weight: 400;
            color: #332e2c;
            line-height: 44px;
            margin-top: 32px;
        }

        .normal-box-title-line {
            width: 531px;
            height: 24px;
            background: #ffdbc1;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            z-index: -99;
        }
    }
}
.normal-box-infor {
    height: 314px;
    background: rgba(255,135,46,0.80);
    border-radius: 50px 50px 0px 0px;
    box-shadow: 0px 4px 0px 0px rgba(255,255,255,0.50) inset; 
    backdrop-filter: blur(6px);
    p {
        font-size: 22px;
        font-family: $font-family;
        font-weight: 400;
        color: #ffffff;
        line-height: 44px;
        width: $width;
        margin: $margin;
        margin-top: 40px;
    }
}
.normal-box-common {
    position: relative;
    // background: #ffffff;
    padding-top: 62px;
    h3 {
        font-size: 40px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 52px;
        letter-spacing: 4px;
        margin: 0;
    }
    span {
        display: inline-block;
    }
    .high-box-arrow-left {
        width: 0;
        height: 0;
        border-top: 13px solid transparent;
        border-right: 17px solid #ffba57;
        border-bottom: 13px solid transparent;
    }
    .high-box-arrow-right {
        width: 0;
        height: 0;
        border-top: 13px solid transparent;
        border-left: 17px solid #ffba57;
        border-bottom: 13px solid transparent;
    }
}
.normal-box-common1 {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        color: #333333;
    }
}
.normal-box-tips-bg {
    background: #ffffff;
    height: 581px;
    padding: 0 18px;
    box-sizing: border-box;
    position: relative;
    .normal-box-tips-time {
        width: $width;
        margin: $margin;
        position: relative;
        top: 228px;
    }
    .normal-box-tips-line {
        display: inline-block;
        width: $width;
        height: 10px;
        border-top:  2px dashed #e1e4eb;
    }
    .normal-box-tips-arrow {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-left: 16px solid #ffbe62;
        border-bottom: 8px solid transparent;
        position: absolute;
        right: 0;
        z-index: 99;
        top: -5px;
    }
    .normal-box-tips-list {
        width: $width;
        margin: $margin;
    }
    .normal-box-tips {
        position: relative;
        top: 170px;
        .normal-box-tips-circle {
            display: inline-block;
            width: 14px;
            height: 14px;
            background: #ffbe62;
            border-radius: 50%;
        }
        .normal-box-tips-arrow1 {
            display: inline-block;
            width: 0;
            height: 0;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
        .normal-box-tips-item-common1 {
            margin-left: -56px;
            position: relative;
            .normal-box-tips-circle {
                position: relative;
                left: 125px;
                top: 35px;
            }
            .normal-box-tips-line1 {
                position: relative;
                left: 94px;
            }
        }
        .normal-box-tips-item2 {
            margin-left: 44px;
        }
        .normal-box-tips-item3 {
            .normal-box-tips-content {
                margin-top: 65px;
            }
            .normal-box-tips-arrow1 {
                border-left: 11px solid transparent;
                border-right: 11px solid transparent;
                border-bottom: 11px solid #ffe2cc;
                position: absolute;
                top: 73px;
            }
            .normal-box-tips-arrow1:after {
                content: '';
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-bottom: 13px solid #fff5ed;
                position: absolute;
                top: -1px;
                left: -10px;
            }
        }
        .normal-box-tips-item4 {
            margin-left: -48px;
        }
        .normal-box-tips-item5 {
            margin-left: -48px;
            .normal-box-tips-content {
                margin-top: 65px;
            }
            .normal-box-tips-arrow1 {
                border-left: 11px solid transparent;
                border-right: 11px solid transparent;
                border-bottom: 11px solid #ffe2cc;
                position: absolute;
                top: 72px;
            }
            .normal-box-tips-arrow1:after {
                content: '';
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-bottom: 13px solid #fff5ed;
                position: absolute;
                top: 0px;
                left: -10px;
            }
        }
        .normal-box-tips-item6 {
            margin-left: -60px;
        }
        .normal-box-tips-item-common {
            position: relative;
            top: -132px;
            .normal-box-tips-arrow1 {
                border-left: 11px solid transparent;
                border-right: 11px solid transparent;
                border-top: 11px solid #ffe2cc;
            }
            .normal-box-tips-arrow1:after {
                content: '';
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-top: 13px solid #fff5ed;
                position: absolute;
                top: -13px;
                left: -10px;
            }
        }
        .normal-box-tips-content {
            width: 264px;
            height: 133px;
            background: #fff5ed;
            border-radius: 20px;
            border: 1px solid #ffe2cc;
            box-shadow: 0px 2px 12px 0px rgba(223,198,177,0.33); 
            padding: 14px;
            box-sizing: border-box;
            font-size: 16px;
            font-family: $font-family;
            font-weight: 400;
            text-align: justify;
            color: #666666;
            line-height: 32px;
            span {
                display: inline-block;
                color: #ff872e;
                font-weight: 400;
                margin-bottom: 4px;
                font-size: 24px;
            }
        }
    }
}
.normal-box-school {
    background: url('../../assets/images/high-school.jpg') no-repeat;
    background-size: cover;
    width: 100%;
    min-height: 600px;
    padding-bottom: 46px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .normal-box-school-infor {
        margin: $margin;
        padding: 0 5%;
        margin-top: 64px;
        min-width: $width;
        max-width: 1660px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .normal-box-school-input {
            width: $width;
            margin: $margin;
        }
        .menu-tools-ul {
            position: absolute;
            width: $width;
            margin: $margin;
            z-index: 9999;
            left: 0px;
            top: 39px;
            height: 290px;
            > div {
                padding: 32px;
                 background: rgba(255, 255, 255, 0.80);
                border-radius: 10px;
                box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.10);
                width: $width;
                backdrop-filter: blur(6px);
                position: absolute;
                box-sizing: border-box;
                left: 0px;
                top: 30px;
            }
            
        }
        .province-list {
            @include gflex;
            font-size: 0;
            align-items: flex-start;
            justify-content: space-between;
            margin-bottom: 6px;

            .title-box {
                width: 78px;
                font-size: 14px;
                text-align: right;
                color: #909399;
                height: 22px;
            }

            a {
                display: inline-block;
                font-size: 14px;
                color: #5e6166;
                cursor: pointer;
                text-align: center;
                margin-bottom: 10px;
                padding: 0 5px;
                height: 22px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            a:not(:nth-child(13n)) {
                margin-right: 12px;
            }

            .active-tag {
                color: #ffffff !important;
                background: $common-color;
                border-radius: 4px;
            }

            a:hover {
                color: $common-color;
            }

            .province-name {
                @include gflex;
                width: calc(100% - 4px);
                justify-content: flex-start;
                flex-wrap: wrap;
            }
        }
        .normal-box-school-input-btns {
            text-align: right;
            button {
                width: 76px;
                height: 44px;
                background: #ffffff;
                border: 1px solid #c4c7cc;
                border-radius: 8px;
                font-size: 16px;
                color: #5e6166;
                margin: 0!important;
            }
            .normal-box-school-input-confirm {
                background: linear-gradient(90deg,#ffa94a, #ff913c);
                border-color: transparent;
                color: #ffffff;
                margin-left: 16px!important;
            }
        }
    }
}
.normal-box-question {
    background: url('../../assets/images/high-question.png') no-repeat;
    background-size:100% 100%;
    min-height: 690px;
    width: 100%;
    .normal-box-question-list {
        width: $width;
        margin: $margin;
    }
}
.normal-box-nan {
    width: 100%;
    height: 642px;
    background: #ffffff;
    position: relative;
    .normal-box-you-title {
        color: #d1e1db;
    }
    img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 64px;
    }
    .normal-box-nan-item {
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(6px);
        color: #2c3331;
        font-size: 24px;
        font-weight: 400;
        margin: $margin;
        padding: 0 30px;
        text-align: center;
        line-height: 36px;
        width: 296px;
        height: 114px;
        background: #ffffff;
        border: 2px solid #ff8820;
        border-radius: 20px;
        box-shadow: 0px 0px 20px 0px rgba(0,156,92,0.11); 
    }
    .normal-box-nan-list {
        width: 900px;
        margin: $margin;
        margin-bottom: 164px;
    }
}
.normal-box-step {
    height: 560px;
    width: 100%;
    background: #fff5ed;
    .normal-box-step-list {
        width: $width;
        margin: $margin;
        margin-top: 110px;
        position: relative;
    }
    .normal-box-step-item {
        position: relative;
        width: 258px;
    }
    .normal-box-step-title {
        width: 258px;
        height: 265px;
        background: #ffffff;
        border-radius: 20px;
        box-shadow: 0px 5px 0px 0px #ffd0a6; 
        padding: 29px;
        box-sizing: border-box;
        div {
            width: 74px;
            height: 74px;
            background: #ffba57;
            border-radius: 43px;
            font-size: 40px;
            font-family: 'Impact';
            font-weight: 400;
            text-align: center;
            color: #fff6e8;
            line-height: 74px;
            margin: 0 auto;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -40px;
        }
        p {
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            color: #66605e;
            line-height: 36px;
            margin-top: 24px;

        }
    }
    .normal-box-step-item-line {
        display: inline-block;
        width: 45px;
        border-top: 2px dashed #ffd794;
        position: absolute;
        left: 258px;
        top: 50%;
        transform: translateY(-50%);
    }
    .normal-box-step-item-arrow {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-left: 16px solid #ffd794;
        border-bottom: 8px solid transparent;
        position: absolute;
        left: 300px;
        top: 50%;
        transform: translateY(-50%);
    }
}
.normal-box-service {
    height: 1251px;
    background: url('../../assets/images/high-school.jpg') no-repeat;
    background-size: cover;
    width: 100%;
    background-position: center;
    margin-bottom: -56px;
    .normal-box-service-list {
        width: $width;
        margin: $margin;
        margin-top: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        img {
            margin-bottom: 32px;
        }
        .el-row {
            padding: 0 0 0 70px;
        }
        .el-col {
            margin-bottom: 22px;
        }
    }
}
.normal-box-order {
    @include gwidth;
    width: 1200px;
    height: 398px;
    background: rgba(255,255,255,0.20);
    border-radius: 20px;
    box-shadow: 0px 8px 20px 0px rgba(216,92,0,0.16), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(6px);
    padding: 47px 0 47px 80px;
    margin-top: 40px;
    position: relative;
    margin-bottom: 28px;
    .normal-box-order-title {
        font-size: 36px;
        font-family: 'zihun443hao';
        color: #ffffff;
    }
    .el-col-9 {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        .normal-box-order-img {
            width: 200px;
            height: 200px;
            background: #ffffff;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 16px;

        }

        p {
            font-size: 24px;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            line-height: 33px;
            margin: 0;
            margin-top: 8px;
        }
    }
}
.normal-box-service-diff {
    .normal-box-order {
        background: linear-gradient(180deg,#ff9e4a, $common-color);
        height: 255px;
        border-radius: 20px;
        box-shadow: 0px 8px 30px 0px rgba(255,97,26,0.38);
        margin-top: -40px;
        img {
            position: absolute;
            top:0;
            left: 0;
        }
        .normal-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
}
.no-data-box {
    // position: relative;
    // top: 90px;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // text-align: center;
    margin-top: 100px;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        // text-align: center;
        color: #666666;
        margin-left: 14px;
    }
}
</style>